import { createTheme } from "@mui/material/styles";

import paperBackFirstImg from "../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../assets/images/masks/paper-back-2.svg";

export const getTheme = (lightMode) => {
  const customRedPalette = {
    extraLight: "#305890",
    light: "#2a4c7d", // En açık kırmızı tonu
    main: lightMode ? "#23416a" : "#ffffff", // Ana kırmızı tonu
    dark: "#1D3557", // Koyu kırmızı tonu
    extraDark: "#172944", // Koyu kırmızı tonu
    hardDark: "#101e31", // Bu kırmızı tonları ile kontrast oluşturacak metin rengi
    orange: "#FA7317",
  };

  // İlk aşama: Temel tema ayarları
  const baseTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1000, // Burası değiştirildi!
        lg: 1280,
        xl: 1920,
      },
    },
    typography: {
      h1: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h2: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h3: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h4: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h5: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h6: {
        color: lightMode ? "#000000" : "#ffffff",
      },
      h1: {
        color: "#000000",
        fontSize: "38px",
      },
      h2: {
        fontSize: "24px",
      },
    },
    palette: {
      mode: lightMode ? "light" : "dark", // Modu Redux state'ine bağlayın

      customRed: customRedPalette, // Özel kırmızı renk paletinizi tema içine eklediniz

      primary: {
        extraLight: customRedPalette.extraLight,
        light: customRedPalette.light,
        main: customRedPalette.main, // Özelleştirilmiş ana renk
        dark: customRedPalette.dark, // Özelleştirilmiş ana renk
        extraDark: customRedPalette.extraDark, // Özelleştirilmiş ana renk
        hardDark: customRedPalette.hardDark, // Özelleştirilmiş ana renk
      },
      secondary: {
        main: "#6800E7", // Özelleştirilmiş ikincil renk
      },
      error: {
        light: "#d90000",
        main: "#bf0000", // Hata mesajları için renk
        dark: "#a60000",
      },

      text: {
        secondary: lightMode ? "#637381" : "#fff", // ✨ Burayı istediğin gibi değiştir
      },
    },
  });

  return createTheme({
    ...baseTheme,
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            boxShadow: "unset",
            filter: "unset",
            // boxShadow:
            //   "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
            borderRight: lightMode ? "1px solid #f2f3f5" : "1px solid #393939 ",
            overflow: "hidden",
            scrollbarWidth: "none",
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            MuiSvgIcon: {
              styleOverrides: {
                root: {
                  color: lightMode ? "#ffffff" : "#ffffff",
                },
              },
            },
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: lightMode ? "#000000" : "#ffffff",
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            borderRadius: "1rem",
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            borderRadius: "1rem",
            maxHeight: "200px", // Açılır menünün maksimum yüksekliği

            backgroundColor: `rgba(${
              lightMode ? "255 255 255" : "28 37 46"
            } / 0.9)`,
            backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
            backgroundSize: "50%, 50%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right top, left bottom",
            backdropFilter: "blur(20px)",
            transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
            outline: 0,
            borderRadius: "1rem",
          },
          // list: {
          //   borderRadius: "1rem !important",
          // },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            // Butonların genel stil özellikleri
            borderRadius: "1rem",
            textTransform: "none",
          },
          containedPrimary: {
            // "primary" varyantı için özel stiller
            backgroundColor: lightMode
              ? baseTheme.palette.primary.main
              : "#23416a",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#23416a",
            },
          },
          containedSecondary: {
            // "secondary" varyantı için özel stiller
            backgroundColor: "#2267C9",
            color: "#ffffff",
            // borderRadius: 0,
            "&:hover": {
              backgroundColor: "#2062BF ",
            },
          },
          containedSuccess: {
            backgroundColor: "#69C05C",
            "&:hover": {
              backgroundColor: "#58b94a",
            },
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            borderRadius: "1rem !important",
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            color: "#ffffff",
          },
        },
      },
      MuiBox: {
        styleOverrides: {
          root: {
            borderRadius: "1rem !important",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: `rgba(${
              lightMode ? "255 255 255" : "28 37 46"
            } / 0.9)`,
            backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
            backgroundSize: "50%, 50%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right top, left bottom",
            backdropFilter: "blur(20px)",
            transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
            outline: 0,
            borderRadius: "1rem",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            filter: "drop-shadow(0px 3px 6px #00000029)", // Bu satırı ekleyin,
            boxShadow: "none",
            backgroundColor: lightMode ? "#ffffff" : "#292929",
            borderRadius: 0,

            // "&.MuiPopover-paper-MuiMenu-paper": {
            //   borderRadius: "1rem",
            // },
          },
          // rounded: {
          //   borderRadius: "1rem",
          // },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {},
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
            filter: "none",
            background: lightMode ? "#fff" : "#292929",
            boxShadow: lightMode
              ? `0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)`
              : "none",
          },
        },
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
            "&.Mui-focused.MuiOutlinedInput-notchedOutline": {
              borderColor: lightMode
                ? `${baseTheme.palette.primary.main}`
                : "#ffffff !important", // Normal durumda label rengi
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: lightMode
                ? `${baseTheme.palette.primary.main}`
                : "#ffffff", // Normal durumda label rengi
            },
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
            // backgroundColor: "#f5f5f5",
            border: "none",
          },
        },
      },
      MuiTableContainer: {
        styleOverrides: {
          root: {
            filter: "drop-shadow(0 0 1px #00000021)",
            padding: "1rem",
            borderRadius: "1rem",
          },
        },
      },
      MuiPickersPopper: {
        styleOverrides: {
          paper: {
            borderRadius: "1rem",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            // Tüm TableCell'lar için genel stil özellikleri
          },
          head: {
            // Sadece başlık hücreleri için özel stil
            fontWeight: "bold",
            textTransform: "uppercase",
            color: lightMode ? "#212121" : "#ffffff",
            height: "70px",
            lineHeight: { xs: "40px" },
            background: lightMode ? "#ffffff" : "#292929",

            borderBottom: "2px solid red",
          },
          body: {
            height: "70px",
            background: lightMode ? "#ffffff" : "#303030",
            border: "none",
            borderBottom: "1px dashed #e9ecee",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            // TableRow'lar için genel stil özellikleri
            // "&:hover": {
            //   backgroundColor: "#ffffff !important",
            // },
            // "&:not(:last-child)": {
            //   ".MuiTableCell-root": {
            //     borderBottom: "1px solid #e0e0e0",
            //   },
            // },
            "&:last-child": {
              ".MuiTableCell-root": {
                borderBottom: `1px solid  ${
                  lightMode ? `#70707013` : `#515151`
                }`,
              },
            },
          },
        },
      },
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
            // Tüm PaginationItem'lar için genel stil özellikleri
          },
          page: {
            '&[aria-current="true"]': {
              backgroundColor: baseTheme.palette.primary.main,
              borderColor: baseTheme.palette.primary.main,
              color: lightMode ? "#ffffff" : "#000000",
              "&:hover": {
                backgroundColor: baseTheme.palette.primary.main,
                opacity: 0.9,
              },
            },
          },
        },
      },
      MuiPopper: {
        styleOverrides: {
          root: {
            zIndex: "999999999999 !important",
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            borderRadius: "1rem",
            zIndex: "999999999999 !important",
            outline: "none",
            border: "none",
          },
        },
      },

      // MuiSelect: {
      //   styleOverrides: {
      //     root: {
      //       maxWidth: "250px",
      //     },
      //   },
      // },
      // MuiFormControl: {
      //   styleOverrides: {
      //     root: {
      //       maxWidth: "250px",
      //       width: "100%", // Genişliği yüzde 100 yaparak, ebeveyninin genişliğine göre sığmasını sağlayabiliriz, ancak maksimum 250px olacaktır.
      //     },
      //   },
      // },
    },
  });
};
